// const getTokenFromApi = async () => {
//     const apiEndpoint: string = import.meta.env.VITE_APP_URL ?? 'http://localhost:8080'
//
//     const res = await fetch(apiEndpoint + '/sanctum/csrf-cookie')
//
//     console.log(res.headers ?? apiEndpoint)
// }

const getTokenFromCookie = () => {
    const xsrfCookie = document.cookie.split(';').find((cookie) => {
        return cookie.includes('XSRF')
    })

    return xsrfCookie.slice(xsrfCookie.indexOf('=') + 1, -1)
}

const getTokenFromHtml = () => {
    const element = document.head.querySelector('[name="csrf-token"]')

    return element?.getAttribute('content')
}

export const getToken = (provider: 'cookie' | 'api' | 'html') => {
    if (provider === 'cookie') {
        return getTokenFromCookie()
    }
    if (provider === 'api') {
        console.error('not supportet')
        // return getTokenFromApi()
        return ''
    }
    if (provider === 'html') {
        return getTokenFromHtml()
    }
}
